import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

export default ({ breakpoints }: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      maxWidth: '100%',
      height: '100%',
    },
    content: {
      'scrollbar-gutter': 'stable',
      position: 'absolute',
      top: 50,
      left: 60,
      width: 'calc(100% - 60px)',
      height: 'calc(100% - 50px)',
      overflowY: 'auto',
      padding: '15px 74px',
      [breakpoints.down('md')]: {
        padding: '5px 5px',
      },
      boxSizing: 'border-box',
    },
    contentMobile: {
      top: '60px',
      left: '10px',
      width: 'calc(100% - 20px)',
      height: 'calc(100% - 60px)',
      padding: 10,
      position: 'absolute',
      boxSizing: 'border-box',
      overflowY: 'auto',
    },
    container: {
      width: 1500,
      maxWidth: '100%',
      margin: '0 auto',
    },
  });
